import { useNavigate, useParams } from 'react-router';
import { Button, Heading1, Input } from '@/components/elements';
import { useMethod } from '@roc-digital/ui-lib';
import { deleteFile, readFile, updateFile } from '@/logic/files';
import { Loading } from '@roc-digital/ui-web';
import { confirm } from '@/components/elements/FileExplorer/ConfirmModal';
import { toast } from 'react-toastify';
import { inputProps, useObjectSetter } from '@/hooks/useObjectSetter';
import { FormGroup } from '@/components/elements/FormGroups';
import React from 'react';

export function ViewImage() {
  const navigate = useNavigate();
  const {id} = useParams();
  const changesRef = React.useRef(false)
  const readQuery = useMethod(readFile, {
    autoRun: id ? [id] : undefined,
    onSuccess: () => {
      changesRef.current = false;
    }
  });

  const fileForm = useObjectSetter(readQuery.result || {}, (changes) => {
    changesRef.current = true;
    readQuery.setResult(changes);
  });
  const metaForm = useObjectSetter(fileForm.meta || {}, changes => fileForm.set('meta', changes));

  const file = readQuery.result || {};

  const deleteQuery = useMethod(deleteFile, {
      async onBefore(args) {
        if(!file) return undefined
        if(!await confirm(<>
          Are you sure you want to delete this file?  <b> 
          - {file.name} </b>
          </>, 'Delete File')) {
          return undefined;
        }
        return args;
      },
      onSuccess: () => {
        toast.success('File deleted.');
        navigate('/images')
      },
       onError: () => {
        toast.error('Error deleting file.')
       }
    });

    const updateQuery = useMethod(updateFile, {
      async onBefore(args) {
        if(!file) return undefined
        if(!await confirm(<>
          Changing the attribution will not update the attribution text in existing articles.
          </>, 'Save Changes')) {
          return undefined;
        }
        return args;
      },
      onSuccess: () => {
        toast.success('File Updated');
        readQuery.reload();
      },
       onError: () => {
        toast.error('File Updated')
       }
    });

  const update= () => {
    updateQuery.run(readQuery.result);
  }


  return (
    <div className="flex flex-col w-4/5">
      <div className="flex h-16 mr-6 mt-3 align-middle items-center" style={{gap: 8}}>
        <Heading1 className="text-2xl text-black">View Image</Heading1>
        <span className='flex-grow'></span>
        <Button variant='primary' size='sm' clickEvent={update} disabled={!changesRef.current} >Save Changes</Button>
        <Button variant='destructive' size='sm' clickEvent={() => deleteQuery.run(file?.id)} >Delete Image</Button>
      </div>
      <div className="flex-grow bg-white p-10 mr-6 rounded">

        <pre>
          <b>Name:</b> {file.name} <br/>
          <b>Created:</b> {formateDate(file.created)} <br/>
          <b>Image Url:</b> {file.src} <br/> <br/>

          <FormGroup title="Name">
            <Input {...inputProps(fileForm, 'name')} />
          </FormGroup>
          <FormGroup title="Title">
            <Input {...inputProps(metaForm, 'title')} />
          </FormGroup>
          <FormGroup title="Description">
            <Input {...inputProps(metaForm, 'description')} />
          </FormGroup>
          <FormGroup title="Attribution">
            <Input {...inputProps(metaForm, 'attribution')} />
          </FormGroup>
          <FormGroup title="Creator">
            <Input {...inputProps(metaForm, 'creator')} />
          </FormGroup>
          <FormGroup title="Credit">
            <Input {...inputProps(metaForm, 'credit')} />
          </FormGroup>

          <br/>


          <img src={file.src} style={{maxWidth: '50vw'}}/>

        </pre>
        {/* <FileExplorer/> */}
        {readQuery?.loading ? <Loading /> : null}
      </div>
    </div>
  );
};

function formateDate(date?: number) {
  if(!date) return '';
  return new Date(date * 1000).toLocaleString();
}